import { cloneDeep } from "lodash-es";
import Utils from "../../../util";
import { ResultRow } from "../../data-structures/results/result-row.model";
import { TechnicalResultsGeneral } from "./general/general-tech-results.model";
import { NPKAnalysis } from "./npk-analysis.model";
import { PlantProductDemand } from "./ppd/ppd.model";

export interface TechnicalResultsInterface {
 'RESULTS.DATA.TECHNICAL.GENERAL'?: TechnicalResultsGeneral;
 'RESULTS.DATA.TECHNICAL.PPD'?: PlantProductDemand;
 'RESULTS.DATA.TECHNICAL.NPKA'?: Record<string, NPKAnalysis>;
 'RESULTS.DATA.TECHNICAL.GHGE'?: GreenhouseGasEstimation;
  fuel_rates?: Record<string, number>;
  product_rates?: Record<string, number>;
}

export class TechnicalResults {
  'RESULTS.DATA.TECHNICAL.GENERAL';
  'RESULTS.DATA.TECHNICAL.PPD';
  'RESULTS.DATA.TECHNICAL.NPKA';
  'RESULTS.DATA.TECHNICAL.GHGE'?;
  fuel_rates;
  product_rates;

  get general() {
    return this['RESULTS.DATA.TECHNICAL.GENERAL'];
  }
  set general(value: TechnicalResultsGeneral) {
    this['RESULTS.DATA.TECHNICAL.GENERAL'] = value;
  }
  get ppd() {
    return this['RESULTS.DATA.TECHNICAL.PPD'];
  }
  set ppd(value: PlantProductDemand) {
    this['RESULTS.DATA.TECHNICAL.PPD'] = value;
  }
  get npka() {
    return this['RESULTS.DATA.TECHNICAL.NPKA'];
  }
  set npka(value: Record<string, NPKAnalysis>) {
    this['RESULTS.DATA.TECHNICAL.NPKA'] = value;
  }
  get ghge() {
    return this['RESULTS.DATA.TECHNICAL.GHGE'];
  }
  set ghge(value: GreenhouseGasEstimation) {
    this['RESULTS.DATA.TECHNICAL.GHGE'] = value;
  }

  constructor(param: TechnicalResultsInterface = {}) {
    this['RESULTS.DATA.TECHNICAL.GENERAL'] = param['RESULTS.DATA.TECHNICAL.GENERAL']
      ? new TechnicalResultsGeneral(param['RESULTS.DATA.TECHNICAL.GENERAL'])
      : new TechnicalResultsGeneral();

    this['RESULTS.DATA.TECHNICAL.PPD'] = param['RESULTS.DATA.TECHNICAL.PPD']
      ? new PlantProductDemand(param['RESULTS.DATA.TECHNICAL.PPD'])
      : new PlantProductDemand();

    if (param['RESULTS.DATA.TECHNICAL.GHGE']) {
      this['RESULTS.DATA.TECHNICAL.GHGE'] = new GreenhouseGasEstimation(param['RESULTS.DATA.TECHNICAL.GHGE']);
    } else {
      delete this['RESULTS.DATA.TECHNICAL.GHGE']
    }

    this['RESULTS.DATA.TECHNICAL.NPKA'] = Utils.ObjectMapper(
      param['RESULTS.DATA.TECHNICAL.NPKA'] || {},
      (val) => { return new NPKAnalysis(val) }
    );

    this.fuel_rates = param.fuel_rates || {};
    this.product_rates = param.product_rates || {};
  }

  deepCopy() {
    return new TechnicalResults(cloneDeep(this));
  }
}

interface GreenhouseGasEstimationInterface {
 'RESULTS.DATA.TECHNICAL.GHG'?: GreenhouseGas;
}
class GreenhouseGasEstimation {
  'RESULTS.DATA.TECHNICAL.GHG';
  get ghg() {
    return this['RESULTS.DATA.TECHNICAL.GHG'];
  }
  set ghg(value: GreenhouseGas) {
    this['RESULTS.DATA.TECHNICAL.GHG'] = value;
  }

  constructor(param: GreenhouseGasEstimationInterface = {}) {
    this['RESULTS.DATA.TECHNICAL.GHG'] = param['RESULTS.DATA.TECHNICAL.GHG']
      ? new GreenhouseGas(param['RESULTS.DATA.TECHNICAL.GHG'])
      : new GreenhouseGas();
  }

  deepCopy() {
    return new GreenhouseGasEstimation(cloneDeep(this));
  }
}

interface GreenhouseGasInterface {
 'RESULTS.DATA.TECHNICAL.EGHGR'?: ResultRow;
}
class GreenhouseGas {
  'RESULTS.DATA.TECHNICAL.EGHGR';
  get eghgr() {
    return this['RESULTS.DATA.TECHNICAL.EGHGR'];
  }
  constructor(param: GreenhouseGasInterface = {}) {
    this['RESULTS.DATA.TECHNICAL.EGHGR'] = param['RESULTS.DATA.TECHNICAL.EGHGR']
      ? new ResultRow(param['RESULTS.DATA.TECHNICAL.EGHGR'])
      : new ResultRow();
  }

  deepCopy() {
    return new GreenhouseGas(cloneDeep(this));
  }
}
